import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { s360ConfigService } from "../Services/S360Config";

class RadioButton extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-initial-form-radiobutton-container" style={this.formInputBoxContainerStyle()} >
                                <fieldset style={{"border":"1px solid silver","margin":"6px -1px","padding":".35em .625em .75em","borderRadius":"5px"}}>

                                    <legend style={{"display":"block","width":"auto","padding":"2px","marginBottom":"0","fontSize":"13px","lineHeight":"inherit","color":"#333","border":"0","borderBottom":"none"}}>{this.props.item.label}</legend>

                <div className="s360-initial-form-radiobutton-option" style={this.formInputBoxStyle()}>
                    <div>
                        {this.props && this.props.item.options && this.props.item.options.map((eachOption, index) => {
                            return <div key={index} style={{display:"flex", alignItems:"center", marginBottom:"4px"}}>
                                <input type="radio" name={this.props.item.label} value={eachOption} onChange={() => { this.onOptionChange(eachOption); }} style={{marginRight:"5px"}} />
                                <span>{eachOption}</span>
                            </div>
                        })}
                    </div>
                </div >
                </fieldset>
            </div>
        );
    }

    selectedOption = null;
    onOptionChange = (option) => {
        this.selectedOption = option;
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor:     s360ConfigService.config.designDetails.headerColor,
            backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor,
            marginTop: "5px"
        }
    }

    value = () => {
        if (!this.selectedOption) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.selectedOption; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && !this.selectedOption);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }
}

export default RadioButton;